import { put, takeLatest } from 'redux-saga/effects';
import { UserAPI } from 'api/user';
import { success } from 'data/current-user-profile';
import { logger } from 'services';
import { saveCurrentUserProfileSagaAction } from '../actions';
function* saveCurrentUserProfileSaga(action) {
    const { payload: { user, handleError, handleSuccess, handleAlways } } = action;
    try {
        const profile = yield UserAPI.save(user);
        yield put(success({
            user: profile
        }));
        if (handleSuccess) {
            handleSuccess();
        }
    } catch (error) {
        logger.error('User save failed', {
            error
        });
        if (handleError) {
            handleError();
        }
    }
    if (handleAlways) {
        handleAlways();
    }
}
export const watchSaveCurrentUserProfileSaga = function*() {
    yield takeLatest(saveCurrentUserProfileSagaAction.type, saveCurrentUserProfileSaga);
};
